import React, { useState, useEffect } from 'react'
import { Modal, Table, Button, Form } from 'react-bootstrap'

const ChatSettingsModal = ({
    show,
    onClose,
    onSave,
    selections = [],
    links = [],
    kedo,
    chatData,
}) => {
    const [localSelections, setLocalSelections] = useState([])

    // Sync local copy with prop
    useEffect(() => {
        setLocalSelections(selections)
    }, [selections, show])

    const toggleLink = (link) => {
        setLocalSelections((prev) => {
            const exists = prev.find((l) => l.id === link.id)
            if (exists) {
                return prev.filter((l) => l.id !== link.id)
            } else {
                return [
                    ...prev,
                    { id: link.id, name: link.name, description: '' },
                ]
            }
        })
    }

    const updateDescription = (id, desc) => {
        setLocalSelections((prev) =>
            prev.map((l) => (l.id === id ? { ...l, description: desc } : l))
        )
    }

    const handleSave = () => {
        localStorage.setItem(
            `chat_link_selections_${chatData.dossier.def_dossier_id}`,
            JSON.stringify(localSelections)
        )
        onSave(localSelections)
        onClose()
    }

    const handleClear = () => {
        setLocalSelections([])
        localStorage.removeItem(
            `chat_link_selections_${chatData.dossier.def_dossier_id}`
        )
        onSave([])
    }

    const isSelected = (id) => localSelections.some((l) => l.id === id)

    return (
        <Modal
            show={show}
            onHide={onClose}
            size="lg"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    ⚙️{' '}
                    {kedo.t(
                        'BitBean - Add links to understand your questions better.'
                    )}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p className="text-muted mb-3">
                    {kedo.t(
                        'Select one or more dossier links and optionally add descriptions.'
                    )}
                </p>

                <div style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                    <Table striped bordered hover responsive size="sm">
                        <thead className="thead-light">
                            <tr>
                                <th style={{ width: '40px' }}></th>
                                <th>{kedo.t('Name')}</th>
                                <th>{kedo.t('Description')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {links.map((link) => {
                                const selected = isSelected(link.id)
                                const desc =
                                    localSelections.find(
                                        (l) => l.id === link.id
                                    )?.description || ''
                                return (
                                    <tr key={link.id}>
                                        <td>
                                            <Form.Check
                                                type="checkbox"
                                                checked={selected}
                                                onChange={() =>
                                                    toggleLink(link)
                                                }
                                            />
                                        </td>
                                        <td>{link.name}</td>
                                        <td>
                                            {selected ? (
                                                <Form.Control
                                                    type="text"
                                                    size="sm"
                                                    value={desc}
                                                    placeholder={kedo.t(
                                                        'Add description...'
                                                    )}
                                                    onChange={(e) =>
                                                        updateDescription(
                                                            link.id,
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            ) : (
                                                <span className="text-muted">
                                                    —
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="outline-secondary" onClick={handleClear}>
                    {kedo.t('Clear All')}
                </Button>
                <Button variant="secondary" onClick={onClose}>
                    {kedo.t('Cancel')}
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    {kedo.t('Save')}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ChatSettingsModal
